import "../pagination.js.org_dist_2.6.0_pagination.min";

const jsPaging = {
  init() {
    jsPaging.create();
  },
  create() {
    if (!$('[data-js-paging]').length) return;
    $('[data-js-paging]').each(function() {
      const self = $(this);
      const postPerPage = self.data('post-per-page') ? parseInt(self.data('post-per-page')) : 30;
      const dataSource = self.find('[data-source]');
      const dataContainer = self.find('[data-container]');
      const dataList = [];

      dataSource.find('[data-item]').each(function() {
        const item = $(this);

        dataList.push(`<li data-item="">${item.html()}</li>`);
      });

      self.pagination({
        dataSource: dataList,
        pageSize: postPerPage,
        hideOnlyOnePage: true,
        callback: function(data, pagination) {
          const html = data.join('');
          dataContainer.html(html);
          if (pagination?.pageSize === 1) {
            self.find('.paginationjs').stop().hide()
          }
        },
      });
    });
  }
};

$(function() {
  jsPaging.init();
});